import { getActiveCompany } from 'src/frontend-common/localstorage';

export const useGetActiveCompanyName = () => {
  const activeCompanyFromStorage = getActiveCompany();
  const activeCompany = activeCompanyFromStorage ? activeCompanyFromStorage.name : 'null';
  return activeCompany;
};
